import React from 'react';
import {
  BankOutlined,
  BarChartOutlined,
  BookOutlined,
  CheckCircleOutlined,
  DownOutlined,
  EditOutlined,
  EllipsisOutlined,
  FormOutlined,
  HistoryOutlined,
  InfoCircleOutlined,
  LockOutlined,
  PlusOutlined,
  ReloadOutlined,
  RiseOutlined,
  RocketOutlined,
  ScanOutlined,
  ShoppingCartOutlined,
  StarOutlined,
  WarningOutlined,
} from '@ant-design/icons';

/** Ant Design icon mapping used instead of lucide in stand-detail redesign components. */
export const fmIconMap: Record<string, React.ReactNode> = {
  // Closest equivalents for the design's lucide icons.
  'lucide-rocket': <RocketOutlined />,
  'lucide-history': <HistoryOutlined />,
  'lucide-edit-3': <EditOutlined />,
  'lucide-refresh-cw': <ReloadOutlined />,
  'lucide-book-open': <BookOutlined />,
  'lucide-trending-up': <RiseOutlined />,
  'lucide-check-circle': <CheckCircleOutlined />,
  'lucide-alert-triangle': <WarningOutlined />,
  'lucide-info': <InfoCircleOutlined />,
  'lucide-lock': <LockOutlined />,
  'lucide-plus': <PlusOutlined />,
  'lucide-shopping-cart': <ShoppingCartOutlined />,
  'lucide-chevron-down': <DownOutlined />,
  'lucide-more-horizontal': <EllipsisOutlined />,
  'lucide-bar-chart-3': <BarChartOutlined />,
  'lucide-landmark': <BankOutlined />,
  'lucide-scan-line': <ScanOutlined />,
  'lucide-pen-tool': <FormOutlined />,
  'lucide-sparkles': <StarOutlined />,
};
